import { useMutation } from "@tanstack/react-query"
import { Creators } from "model/apiWrapper"
import { useDispatch } from "react-redux"

/**
 * Hook to pin an AI artifact as a workflow
 *
 * Makes a POST request to create a pinned workflow from an artifact,
 * returning the pinnedId which can be used to fetch the artifact later.
 *
 * @returns {Object} TanStack Query mutation result with mutateAsync
 *
 */
export function usePinWorkflow() {
  const dispatch = useDispatch()

  return useMutation({
    mutationFn: ({ accountAlias, artifactId, title }) => {
      return new Promise((resolve, reject) => {
        dispatch(Creators.post(
          `/api/${accountAlias}/ai/pin-workflow`,
          { artifactId, title },
          resolve,
          reject,
        ))
      })
    },
  })
}
